import { BaseSizeEnum as e } from "./common.js";
const p = {
  [e.Large]: "24px",
  [e.Medium]: "20px",
  [e.Small]: "16px"
};
export {
  p as BUTTON_ICON_SIZE
};
//# sourceMappingURL=button.js.map
